import { Select } from 'antd';
import type { SelectProps } from 'antd/lib/select';
import type { VFC } from 'react';
import { hardwareCategoriesOptions } from 'routes/reseller-data/routes/hardwares/const';
import { filterOption } from '../utils/filterOption';
import { filterSort } from '../utils/filterSort';

export interface HardwareCategorySelectProps extends SelectProps<number> {
  onChange?: (value: number | null) => void;
}

export const HardwareCategorySelect: VFC<HardwareCategorySelectProps> = ({ onChange, ...propsToPass }) => (
  <Select
    filterOption={filterOption}
    filterSort={filterSort}
    options={hardwareCategoriesOptions}
    onSelect={(id?: number) => onChange?.(id)}
    {...propsToPass}
  />
);
